import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import { Stack } from "@mui/material";

// * Import custom component
import Card from "../../components/Card/Card";
import DescModal from "../../components/AccountSetupComponents/DescModal";
import UserTour from "../../components/UserTour/UserTour";
import { accountSetupStep3 } from "../../components/UserTour/Data/DiscoverSteps";
// * Import kits
import Typography from "../../kit/Typography";

// * Import actions
import {
  accountSetupFunction,
  addFunction,
  removeFunction,
} from "../../redux/slice/accountSetupSlice";

// * Import styles
import { accountSetupStyles } from "../../theme/style";
import { useEffect } from "react";

// * Import utils

// # Components
const FunctionsCard = ({ templateData }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = accountSetupStyles(theme);

  const selectedFunctions =
    useSelector((state) => state.accountSetup.functions) || [];

  const [open, setOpen] = useState(false);
  const [isOthersIncluded, setIsOthersIncluded] = useState(false);
  const userJourney = useSelector((state) => state.auth.userJourney);
  let newUserPageFlag =
    userJourney?.isNewUser &&
    userJourney?.pagesToShow?.["accountSetupFunction"];
  // # Handlers
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (
      selectedFunctions.every((elem) =>
        functionsListExceptOthers.includes(elem)
      )
    ) {
      dispatch(accountSetupFunction(selectedFunctions));
    } else {
      setIsOthersIncluded(true);
      dispatch(accountSetupFunction(selectedFunctions));
    }
  }, []);

  const handleDone = (key, value) => {
    setOpen(false);
    dispatch(accountSetupFunction([value]));
    setIsOthersIncluded(true);
  };

  const functionsListExceptOthers = templateData?.options
    .filter((val) => val.name !== "Others")
    .map((val) => val.name);

  const handleFunctionChange = (key, val) => {
    // checking if card selected is other or not
    if (functionsListExceptOthers.includes(val)) {
      if (selectedFunctions?.includes(val)) {
        setIsOthersIncluded(false);
        dispatch(removeFunction(val));
      } else {
        const updatedFunctions = functionsListExceptOthers.filter((elem) =>
          selectedFunctions.includes(elem)
        );
        setIsOthersIncluded(false);
        dispatch(accountSetupFunction([...updatedFunctions, val]));
      }
    } else {
      setOpen(true);
      if (
        functionsListExceptOthers.some((elem) =>
          selectedFunctions.includes(elem)
        )
      ) {
        dispatch(accountSetupFunction([]));
      } else {
        setIsOthersIncluded(true);
        dispatch(accountSetupFunction(selectedFunctions));
      }
    }
  };

  // # JSX
  return (
    <div>
      <UserTour
        steps={accountSetupStep3}
        isOpen={userJourney?.showJourney || newUserPageFlag}
        page={"accountSetupFunction"}
        newUserPageFlag={newUserPageFlag}
      />
      <DescModal
        selectedValue={selectedFunctions}
        handleClose={handleClose}
        open={open}
        type="function"
        handleDone={handleDone}
        keyField="function"
        functionsListExceptOthers={functionsListExceptOthers}
      />
      <Stack
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            maxWidth: "700px",
            textTransform: "uppercase",
            margin: theme.size[10],
            color: theme.palette.cards.heading,
          }}
        >
          {templateData?.Description}
        </Typography>
      </Stack>
      <div
        id={"functionContent"}
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          className={classes.setupCardListFunctionContainer}
          style={{
            flexDirection: "column",
            gap: theme.sizeRem[3],
            height: "calc(100vh - 350px)",
            overflow: "auto",
          }}
        >
          <div className={classes.setupCardList} style={{ overflowY: "auto" }}>
            {templateData?.options?.length &&
              templateData?.options?.map((item) => {
                const isOtherSelected =
                  item.name === "Others" &&
                  selectedFunctions?.length !== 0 &&
                  isOthersIncluded;
                const otherSelectedValue = selectedFunctions?.join("");
                const displayStyle =
                  selectedFunctions?.includes(item.name) || isOtherSelected
                    ? "block"
                    : "none";
                return (
                  <Card
                    selectedFunctions={selectedFunctions}
                    name={item.name}
                    key={item.name}
                    handleChange={handleFunctionChange}
                    info={item.description}
                    functionsListExceptOthers={functionsListExceptOthers}
                    isOthersIncluded={isOthersIncluded}
                    isOtherSelected={isOtherSelected}
                    otherSelectedValue={otherSelectedValue}
                    screen="functions"
                    displayStyle={displayStyle}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunctionsCard;
